export default __webpack_public_path__ + "static/clutch-global-spring-logo-76331eb47d11409f9d51f659ac254ac4.svg";